import { render, staticRenderFns } from "./MusicListShow.vue?vue&type=template&id=6ba86303&scoped=true&"
import script from "./MusicListShow.vue?vue&type=script&lang=js&"
export * from "./MusicListShow.vue?vue&type=script&lang=js&"
import style0 from "./MusicListShow.vue?vue&type=style&index=0&id=6ba86303&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ba86303",
  null
  
)

export default component.exports